import React, { useState, useEffect, useRef, useCallback } from 'react';
import Axios from 'axios';
import { MapContainer, WMSTileLayer, LayersControl } from 'react-leaflet';
import { useParams } from 'react-router-dom';
import MapIndicators from "./MapIndicators";
import Footer from "../Layout/Footer";
import Button from 'react-bootstrap/Button';

let CancelToken = Axios.CancelToken;
let source = CancelToken.source();
const sigProjectsData = [
  {
    name: 'La Unión 12-24',
    mapZoom: 14,
    mapCenter: [-40.296755338849415, -73.08367399502168],
    mapMaxBounds: [[-40.31715127262344, -73.09779640923553],[-40.265914330153386, -73.04216561610858]],
    data: {
      imgmosaic: { name: 'Mosaico', layername: 'imgmosaic', workspace: 'launion1224' },
      layers: [
        {name: 'Área - Área La Union', layername: 'Area La Union', workspace: 'launion1224v2'},
        {name: 'Área - Catálogo La Unión', layername: 'Catalogo La Union', workspace: 'launion1224v2'},
        {name: 'Construcciones - Altura Edificaciones', layername: 'Altura_Edificaciones', workspace: 'launion1224v2'},
        {name: 'Construcciones - Edificaciones', layername: 'Edificaciones', workspace: 'launion1224v2'},
        {name: 'Construcciones - Estacionamientos', layername: 'Estacionamientos', workspace: 'launion1224v2'},
        {name: 'Construcciones - Invernaderos', layername: 'Invernaderos', workspace: 'launion1224v2'},
        {name: 'Construcciones - Silos', layername: 'Silos', workspace: 'launion1224v2'},
        {name: 'Construcciones - Subestaciones Eléctricas', layername: 'Subestaciones_Electricas', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Bancos', layername: 'Bancos', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Bencineras', layername: 'Bencinera', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Bomberos', layername: 'Bomberos', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Canchas', layername: 'Canchas', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Carabineros', layername: 'Carabineros', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Cementerio', layername: 'Cementerio', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Centro Médico', layername: 'Centro_Medico', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Colegios', layername: 'Colegios', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Escuelas', layername: 'Escuelas', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Estadios', layername: 'Estadios', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Fábricas', layername: 'Fabricas', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Ferreterías', layername: 'Ferreteria', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Gimnasios', layername: 'Gimnasio', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Hospitales', layername: 'Hospital', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Iglesias', layername: 'Iglesias', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Institutos', layername: 'Instituto', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Jardín Infantil', layername: 'Jardin_Infantil', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Juzgado de Letras', layername: 'Juzgado_de_Letras', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Liceos', layername: 'Liceo', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Municipalidad', layername: 'Municipalidad', workspace: 'launion1224v2'},
        {name: 'Equipamiento - OMIL', layername: 'OMIL', workspace: 'launion1224v2'},
        {name: 'Equipamiento - PDI', layername: 'PDI', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Piscinas', layername: 'Piscina', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Registro Civil', layername: 'Registro_civil', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Seremi', layername: 'Seremi', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Supermercados', layername: 'Supermercados', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Terminal de Buses', layername: 'Terminal_de_Buses', workspace: 'launion1224v2'},
        {name: 'Equipamiento - Central Hidroeléctrica', layername: 'central_Hidroelectrica', workspace: 'launion1224v2'},
        {name: 'Predios - Linea de Cierre', layername: 'Linea_de_Cierre', workspace: 'launion1224v2'},
        {name: 'Predios - Linea de Edificacion', layername: 'Linea_de_Edificacion', workspace: 'launion1224v2'},
        {name: 'Predios - Manzanas', layername: 'Manzanas', workspace: 'launion1224v2'},
        {name: 'Predios - Predio Agrícola', layername: 'Predio_Agricola', workspace: 'launion1224v2'},
        {name: 'Predios - Subdivisión Predial', layername: 'Subdivision_Predial', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Acequia', layername: 'Acequia', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Canales', layername: 'Canales', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Estero', layername: 'Estero', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Laguna', layername: 'Laguna', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Río', layername: 'Rio', workspace: 'launion1224v2'},
        {name: 'Red Hidrologica - Tranque', layername: 'Tranque', workspace: 'launion1224v2'},
        {name: 'Servicios - Antenas', layername: 'Antena', workspace: 'launion1224v2'},
        {name: 'Servicios - Base Torre Alta Tensión', layername: 'Base Torre Alta Tensión', workspace: 'launion1224v2'},
        {name: 'Servicios - Camaras', layername: 'Camaras', workspace: 'launion1224v2'},
        {name: 'Servicios - Copa de agua', layername: 'Copa de agua', workspace: 'launion1224v2'},
        {name: 'Servicios - Línea Eléctrica Alta Tensión', layername: 'Linea Electrica Alta Tensión', workspace: 'launion1224v2'},
        {name: 'Servicios - Línea Eléctrica Baja Tensión', layername: 'Lineas Electricas baja tension', workspace: 'launion1224v2'},
        {name: 'Servicios - Luminarias', layername: 'Luminarias', workspace: 'launion1224v2'},
        {name: 'Servicios - Postes', layername: 'Postes', workspace: 'launion1224v2'},
        {name: 'Servicios - Sumideros', layername: 'Sumideros', workspace: 'launion1224v2'},
        {name: 'Servicios - Torres Alta Tensión', layername: 'Torres_Alta_Tension', workspace: 'launion1224v2'},
        {name: 'Topografía - Cota Topográfica', layername: 'Cota_Topografica', workspace: 'launion1224v2'},
        {name: 'Topografía - Curvas de Nivel Indice', layername: 'Curvas de Nivel Indice', workspace: 'launion1224v2'},
        {name: 'Topografía - Curvas de Nivel Intermedias', layername: 'Curvas de Nivel Intermedias', workspace: 'launion1224v2'},
        {name: 'Topografía - Excavaciones', layername: 'Excavaciones', workspace: 'launion1224v2'},
        {name: 'Varios - Letreros', layername: 'Letreros', workspace: 'launion1224v2'},
        {name: 'Varios - Tuberías', layername: 'Tuberia', workspace: 'launion1224v2'},
        {name: 'Varios - Zanjas', layername: 'Zanja', workspace: 'launion1224v2'},
        {name: 'Varios - Zona de Amortiguamiento', layername: 'zona de Amortiguamiento', workspace: 'launion1224v2'},
        {name: 'Vegetación - Arbol Común', layername: 'Arbol_Comun', workspace: 'launion1224v2'},
        {name: 'Vegetación - Arbol Grande', layername: 'Arbol_Grande', workspace: 'launion1224v2'},
        {name: 'Vegetación - Áreas Verdes', layername: 'Areas_Verdes', workspace: 'launion1224v2'},
        {name: 'Vegetación - Paisajismo', layername: 'Paisajismo', workspace: 'launion1224v2'},
        {name: 'Vegetación - Palmeras', layername: 'Palmeras', workspace: 'launion1224v2'},
        {name: 'Vegetación - Plaza', layername: 'Plaza', workspace: 'launion1224v2'},
        {name: 'Vegetación - Sitios Eriazos', layername: 'Sitios_Eriazos', workspace: 'launion1224v2'},
        {name: 'Vialidad - Aceras', layername: 'Aceras', workspace: 'launion1224v2'},
        {name: 'Vialidad - Barreras de Contención', layername: 'Barreras_de_Contencion', workspace: 'launion1224v2'},
        {name: 'Vialidad - Berma', layername: 'Berma', workspace: 'launion1224v2'},
        {name: 'Vialidad - Calzada Asfalto', layername: 'Calzada_Asfalto', workspace: 'launion1224v2'},
        {name: 'Vialidad - Calzada Hormigón', layername: 'Calzada_Hormigon', workspace: 'launion1224v2'},
        {name: 'Vialidad - Calzada Tierra', layername: 'Calzada_Tierra', workspace: 'launion1224v2'},
        {name: 'Vialidad - Ciclovía', layername: 'Ciclovia', workspace: 'launion1224v2'},
        {name: 'Vialidad - Cotas Intersecciónes Calles', layername: 'Cotas_Intersecciones_Calles', workspace: 'launion1224v2'},
        {name: 'Vialidad - Cruces Peatonales', layername: 'Cruces_Peatonales', workspace: 'launion1224v2'},
        {name: 'Vialidad - Ejes', layername: 'Ejes', workspace: 'launion1224v2'},
        {name: 'Vialidad - Linea Férrea', layername: 'Linea_Ferrea', workspace: 'launion1224v2'},
        {name: 'Vialidad - Linea de Solera', layername: 'Linea_de_Solera', workspace: 'launion1224v2'},
        {name: 'Vialidad - Obras de Arte', layername: 'Obra de arte', workspace: 'launion1224v2'},
        {name: 'Vialidad - Paradero', layername: 'Paradero', workspace: 'launion1224v2'},
        {name: 'Vialidad - Pasarela', layername: 'Pasarela', workspace: 'launion1224v2'},
        {name: 'Vialidad - Paso bajo nivel', layername: 'Paso_bajo_nivel', workspace: 'launion1224v2'},
        {name: 'Vialidad - Puente', layername: 'Puente', workspace: 'launion1224v2'},
        {name: 'Vialidad - Puente Ferroviario', layername: 'Puente_Ferroviario', workspace: 'launion1224v2'},
        {name: 'Vialidad - Puente Peatonal', layername: 'Puente_Peatonal', workspace: 'launion1224v2'},
        {name: 'Vialidad - Refugio de Parada', layername: 'Refugio_de_Parada', workspace: 'launion1224v2'},
        {name: 'Vialidad - Rotonda', layername: 'Rotonda', workspace: 'launion1224v2'},
        {name: 'Vialidad - Semáforos', layername: 'Semaforos', workspace: 'launion1224v2'},
        {name: 'Vialidad - Veredas', layername: 'Veredas', workspace: 'launion1224v2'}
      ]
    }
  },
  {
    name: 'Santa Juana 03-25',
    mapZoom: 15,
    mapCenter: [-37.1737794, -72.94259],
    mapMaxBounds: [[-37,18828735592111, -72,96827034406354],[-37,16293815610492, -72,92957708169145]],
    data: {
      imgmosaic: { name: 'Mosaico', layername: 'imgmosaic', workspace: 'stajuana0325' },
      layers: [
        {name: 'Puntos de Control', layername: 'Puntos_de_Control', workspace: 'stajuana0325'},
        {name: 'Construcciones - Altura Edificaciones', layername: 'Altura Edificaciones', workspace: 'stajuana0325'},
        {name: 'Construcciones - Edificaciones', layername: 'Edificaciones', workspace: 'stajuana0325'},
        {name: 'Construcciones - Estacionamientos', layername: 'Estacionamientos', workspace: 'stajuana0325'},
        {name: 'Construcciones - Invernaderos', layername: 'Invernaderos', workspace: 'stajuana0325'},
        {name: 'Construcciones - Silos', layername: 'Silos', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Colegios', layername: 'Colegios', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Cuarteles Policiales', layername: 'Cuartel_policial', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Cuarteles de Bomberos', layername: 'Cuarteles_de_bomberos', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Ferreterías', layername: 'Ferreteria', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Hospitales', layername: 'Hospital', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Iglesias', layername: 'Iglesia', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Jardínes Infantiles', layername: 'Jardines_Infantiles', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Piscinas', layername: 'Piscina', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Restaurantes', layername: 'Restaurantes', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Salas Cuna', layername: 'Sala_Cuna', workspace: 'stajuana0325'},
        {name: 'Equipamiento - Supermercados y Minimarkets', layername: 'Supermercado_y_Minimarket', workspace: 'stajuana0325'},
        {name: 'Predios - Linea de Cierre', layername: 'Linea_Cierre', workspace: 'stajuana0325'},
        {name: 'Predios - Linea de Edificacion', layername: 'Linea_Edificacion', workspace: 'stajuana0325'},
        {name: 'Predios - Manzanas', layername: 'Manzanas', workspace: 'stajuana0325'},
        {name: 'Predios - Predio Agrícola', layername: 'Predio Agricola', workspace: 'stajuana0325'},
        {name: 'Predios - Predios', layername: 'Predios', workspace: 'stajuana0325'},
        {name: 'Predios - Subdivisión Predial', layername: 'Subdivision Predial', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Canales', layername: 'Canales', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Estero', layername: 'Estero', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Laguna', layername: 'Laguna', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Lecho Río', layername: 'Lecho Rio', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Obras de Arte', layername: 'Obras de Arte', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Puente', layername: 'Puente', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Río', layername: 'Rio', workspace: 'stajuana0325'},
        {name: 'Red Hidrologica - Tranque', layername: 'Tranque', workspace: 'stajuana0325'},
        {name: 'Servicios - Antenas', layername: 'Antenas', workspace: 'stajuana0325'},
        {name: 'Servicios - Camaras', layername: 'Camaras', workspace: 'stajuana0325'},
        {name: 'Servicios - Canchas', layername: 'Canchas', workspace: 'stajuana0325'},
        {name: 'Servicios - Cementerio', layername: 'Cementerio', workspace: 'stajuana0325'},
        {name: 'Servicios - Copa de agua', layername: 'Copa de agua', workspace: 'stajuana0325'},
        {name: 'Servicios - Estanques', layername: 'Estanques', workspace: 'stajuana0325'},
        {name: 'Servicios - Grifos', layername: 'Grifos', workspace: 'stajuana0325'},
        {name: 'Servicios - Línea Baja Tensión', layername: 'Linea Baja Tension', workspace: 'stajuana0325'},
        {name: 'Servicios - Línea Media Tensión', layername: 'Linea Media Tension', workspace: 'stajuana0325'},
        {name: 'Servicios - Luminarias', layername: 'Luminarias', workspace: 'stajuana0325'},
        {name: 'Servicios - Postes', layername: 'Postes', workspace: 'stajuana0325'},
        {name: 'Servicios - Sumideros', layername: 'Sumideros', workspace: 'stajuana0325'},
        {name: 'Topografía - Cotas Topográficas', layername: 'Cotas Topograficas', workspace: 'stajuana0325'},
        {name: 'Topografía - Curvas de Nivel Indice', layername: 'Curvas de Nivel Indice', workspace: 'stajuana0325'},
        {name: 'Topografía - Curvas de Nivel Intermedias', layername: 'Curvas de Nivel Intermedias', workspace: 'stajuana0325'},
        {name: 'Varios - Letreros Publicitarios', layername: 'Letreros Publicitarios', workspace: 'stajuana0325'},
        {name: 'Vegetación - Arbol Común', layername: 'Arbol Comun', workspace: 'stajuana0325'},
        {name: 'Vegetación - Arboles Grandes', layername: 'Arboles Grandes', workspace: 'stajuana0325'},
        {name: 'Vegetación - Áreas Verdes', layername: 'Areas Verdes', workspace: 'stajuana0325'},
        {name: 'Vegetación - Masa Arborea', layername: 'Masa Arborea', workspace: 'stajuana0325'},
        {name: 'Vegetación - Palmeras', layername: 'Palmeras', workspace: 'stajuana0325'},
        {name: 'Vegetación - Plazas', layername: 'Plazas', workspace: 'stajuana0325'},
        {name: 'Vegetación - Sitios Eriazos', layername: 'Sitios Eriazos', workspace: 'stajuana0325'},
        {name: 'Vegetación - Terrenos de Cultivo', layername: 'Terrenos de Cultivo', workspace: 'stajuana0325'},
        {name: 'Vialidad - Aceras', layername: 'Acera', workspace: 'stajuana0325'},
        {name: 'Vialidad - Barreras', layername: 'Barreras', workspace: 'stajuana0325'},
        {name: 'Vialidad - Bermas', layername: 'Bermas', workspace: 'stajuana0325'},
        {name: 'Vialidad - Calzadas Asfalto', layername: 'Calzadas Asfalto', workspace: 'stajuana0325'},
        {name: 'Vialidad - Calzadas Hormigón', layername: 'Calzadas Hormigon', workspace: 'stajuana0325'},
        {name: 'Vialidad - Calzadas Tierra', layername: 'Calzadas Tierra', workspace: 'stajuana0325'},
        {name: 'Vialidad - Ciclovías', layername: 'Ciclovias', workspace: 'stajuana0325'},
        {name: 'Vialidad - Cota Intersección Calles', layername: 'Cota Interseccion calles', workspace: 'stajuana0325'},
        {name: 'Vialidad - Cruces Peatonales', layername: 'Cruces peatonales', workspace: 'stajuana0325'},
        {name: 'Vialidad - Ejes', layername: 'Ejes', workspace: 'stajuana0325'},
        {name: 'Vialidad - Muelle', layername: 'Muelle', workspace: 'stajuana0325'},
        {name: 'Vialidad - Obras de Arte', layername: 'Vialidad Obras de Arte', workspace: 'stajuana0325'},
        {name: 'Vialidad - Paraderos', layername: 'Paraderos', workspace: 'stajuana0325'},
        {name: 'Vialidad - Puente', layername: 'Vialidad Puente', workspace: 'stajuana0325'},
        {name: 'Vialidad - Refugio Paraderos', layername: 'Refugio Paraderos', workspace: 'stajuana0325'},
        {name: 'Vialidad - Resalto', layername: 'Resalto', workspace: 'stajuana0325'},
        {name: 'Vialidad - Solera', layername: 'Solera', workspace: 'stajuana0325'},
        {name: 'Vialidad - Veredas', layername: 'Veredas', workspace: 'stajuana0325'}
      ]
    }
  }
]

const Map = () => {

  const [loading, setLoading] = useState(false);
  // const [mapData, setMapData] = useState(false);
  const [isInfoModalOpen, setIsInfoModalOpen] = useState(false);
  const [dataPosToUse, setDataPosToUse] = useState(-1);

  let { projectCode } = useParams();

  const isFirstRender = useRef(true);

  useEffect(() => {
    document.title = "MSTD SIG";
  }, []);

  const GetData = useCallback(() => {
    setLoading(true);

    if (source) {
      source.cancel();
      source = CancelToken.source();
    }

    const opts = {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': {'user': 'default', 'password': 'geoserver'},
      },
      cancelToken: source.token
    };

    const url = '/api/projects/aaa';
    // const url = 'http://localhost:8080/geoserver/rest/layers.json'
    // const url = 'geoserver/rest/layers.json'
    // const url = 'http://localhost:8080/geoserver/rest/workspaces/testmg/layers'
    // const url = 'https://sig.mstdlab.com/geoserver/rest/workspaces/testmg/layers'
    // const url = 'geoserver/rest/workspaces/testmg/layers.json'

    Axios.get(url, opts)
    .then((res) => {
      setLoading(false);
      console.log(res.data);
      // setMapData(res.data);
      
    })
    .catch((err) => {
      setLoading(false);
      console.log(err);
      
      // if (Axios.isCancel(err)) {
      //   alert.show('Petición cancelada', {type: 'info'});
      // } else if (!err.response) {
      //   console.log('Petición cancelada');
      // } else if (err.response.status === 500) {
      //   alert.show('No se recibió respuesta del servidor', {type: 'error'})
      // } else {
      //   alert.show(err.response.data.msg, {type: 'error'})
      // }
    });
  }, []);

  // useEffect(() => {
  //   if(isFirstRender.current){
  //     GetData();
  //   }
  // }, [GetData]);

  useEffect(() => {
    if (projectCode) {
      if (projectCode === "La Unión 12-24") {
        setDataPosToUse(0);
      } else if (projectCode === "Santa Juana 03-25") {
        setDataPosToUse(1);
      }
    }
  }, [projectCode]);
  
  return (
    <>
      <MapIndicators isOpen={isInfoModalOpen} projectCode={projectCode} dataPosToUse={dataPosToUse} closeModal={() => setIsInfoModalOpen(false)} />
      <div className="d-flex flex-column flex-1 h-100">
        <div className="d-flex justify-content-between mx-3 mt-3">
          <h4>{'MSTD SIG' + ((dataPosToUse > -1) ? (' - ' + sigProjectsData[dataPosToUse].name) : '')}</h4>
          <Button variant="primary" onClick={() => setIsInfoModalOpen(true)}>
            Información
          </Button>
        </div>
        { (dataPosToUse > -1) ? 
          <>
            <div className="m-3 h-100 border border-2">
              <MapContainer 
                className="bg-white" 
                center={sigProjectsData[dataPosToUse].mapCenter} 
                zoom={sigProjectsData[dataPosToUse].mapZoom} 
                minZoom={13} 
                maxBounds={sigProjectsData[dataPosToUse].mapMaxBounds} 
                maxBoundsViscosity={1.0} 
                scrollWheelZoom 
                id="map" 
              >
                <WMSTileLayer
                  layers={"TOPO-OSM-WMS"}
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  // attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors|| Build by fmuchembi'
                  // url={`http://ows.mundialis.de/services/service?`}
                  // attribution="Google Maps"
                  // url="https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
                  // url={`https://tile.openstreetmap.org/{z}/{x}/{y}.png`}
                  // url={"https://geoserverp.mstdlab.com/geoserver/"+sigProjectsData[dataPosToUse].data.imgmosaic.workspace+"/wms"}
                  // url={"http://localhost:8080/geoserver/"+raster.workspace+"/wms"}
                  // url={"geoserver/"+raster.workspace+"/wms"}
                  // params={{ 
                  //   format:"image/png", 
                  //   layers: (sigProjectsData[dataPosToUse].data.imgmosaic.workspace + ':' + sigProjectsData[dataPosToUse].data.imgmosaic.layername), 
                  //   transparent: true, 
                  //   maxZoom: 25, 
                  //   maxNativeZoom: 25 
                  // }}
                  maxZoom={25}
                  maxNativeZoom={25}
                  transparent={true}
                />
                <LayersControl position="topright">
                  <LayersControl.Overlay name={'imgmosaic'}>
                    <WMSTileLayer
                      url={"http://localhost:8080/geoserver/"+sigProjectsData[dataPosToUse].data.imgmosaic.workspace+"/wms"}
                      // url={"https://geoserverp.mstdlab.com/geoserver/stajuana0325/wms"}
                      // url={"http://localhost:8080/geoserver/"+raster.workspace+"/wms"}
                      // url={"geoserver/"+raster.workspace+"/wms"}
                      params={{ 
                        format:"image/png", 
                        layers: (sigProjectsData[dataPosToUse].data.imgmosaic.workspace + ':' + sigProjectsData[dataPosToUse].data.imgmosaic.layername), 
                        transparent: true, 
                        maxZoom: 25, 
                        maxNativeZoom: 25 
                      }}
                    />
                  </LayersControl.Overlay>
                  {sigProjectsData[dataPosToUse].data.layers.map((raster, index) => (
                    <LayersControl.Overlay name={raster.name} key={index}>
                      <WMSTileLayer
                        // url={"https://geoserverp.mstdlab.com/geoserver/"+raster.workspace+"/wms"}
                        url={"http://localhost:8080/geoserver/"+raster.workspace+"/wms"}
                        // url={"geoserver/"+raster.workspace+"/wms"}
                        params={{ format:"image/png", layers: (raster.workspace + ':' + raster.layername), transparent: true, maxZoom: 25, maxNativeZoom: 25 }}
                      />
                    </LayersControl.Overlay>
                  ))}
                </LayersControl>
              </MapContainer>



              {/* <MapContainer 
                className="bg-white" 
                center={sigProjectsData[dataPosToUse].mapCenter} 
                zoom={sigProjectsData[dataPosToUse].mapZoom} 
                minZoom={13} 
                maxBounds={sigProjectsData[dataPosToUse].mapMaxBounds} 
                maxBoundsViscosity={1.0} 
                scrollWheelZoom 
                id="map" 
              >
                <WMSTileLayer
                  // layers={"TOPO-OSM-WMS"}
                  attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors|| Build by fmuchembi'
                  // url={`http://ows.mundialis.de/services/service?`}
                  // url={`https://tile.openstreetmap.org/{z}/{x}/{y}.png`}
                  url={"https://geoserverp.mstdlab.com/geoserver/"+sigProjectsData[dataPosToUse].data.imgmosaic.workspace+"/wms"}
                  // url={"http://localhost:8080/geoserver/"+raster.workspace+"/wms"}
                  // url={"geoserver/"+raster.workspace+"/wms"}
                  params={{ 
                    format:"image/png", 
                    layers: (sigProjectsData[dataPosToUse].data.imgmosaic.workspace + ':' + sigProjectsData[dataPosToUse].data.imgmosaic.layername), 
                    transparent: true, 
                    maxZoom: 25, 
                    maxNativeZoom: 25 
                  }}
                  maxZoom={25}
                  maxNativeZoom={25}
                  transparent={true}
                />
                <LayersControl position="topright">
                  {sigProjectsData[dataPosToUse].data.layers.map((raster, index) => (
                    <LayersControl.Overlay name={raster.name} key={index}>
                      <WMSTileLayer
                        url={"https://geoserverp.mstdlab.com/geoserver/"+raster.workspace+"/wms"}
                        // url={"http://localhost:8080/geoserver/"+raster.workspace+"/wms"}
                        // url={"geoserver/"+raster.workspace+"/wms"}
                        params={{ format:"image/png", layers: (raster.workspace + ':' + raster.layername), transparent: true, maxZoom: 25, maxNativeZoom: 25 }}
                      />
                    </LayersControl.Overlay>
                  ))}
                </LayersControl>
              </MapContainer> */}
            </div>
          </>
        : null }
      </div>
      <Footer />
    </>
  )
}

export default Map;